<template>
    <div class="errorPage">
        <div class="errorPage-body">
            <slot></slot>
            <p class="font-size30"
               v-if="data.ms.length>0"
               style="margin-top: 35px">{{data.ms}}
                &nbsp;&nbsp;&nbsp;
                <a v-if="data.ms.length>0"
                   style="text-decoration:underline;"
                   v-show="!noSHowDashboard"
                   @click="$router.push({path: '/mgt/dashboard'})">{{$t('返回首页')}}</a>
            </p>
            <div class="errorPage-body-ms font-size20">{{data.ts}}
                <a v-if="data.ms.length==0"
                   style="text-decoration:underline;font-size:14px;"
                   v-show="!noSHowDashboard"
                   @click="$router.push({path: '/mgt/dashboard'})">{{$t('返回首页')}}</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Error403',
    props: ['data', 'noSHowDashboard'],
    inject: ['reload'],
    methods: {
        routerPush () {
            this.$router.push({ path: '/mgt/dashboard' })
            this.reload()
        }
    }
}
</script>

<style lang="less">
.errorPage {
    &-body {
        position: absolute;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        &-ms {
            color: #999999;
            margin-top: 21px;
        }
        &-title {
            font-size: 240px;
        }
    }
}
</style>
